import {
    FETCH_FLOOR_PLANS_CONTENT,
    FETCH_FLOOR_PLANS_CONTENT_SUCCESS,
    FETCH_FLOOR_PLANS_CONTENT_FAILED,
    FLOOR_PLANS_DELETE__MESSAGE,
    FLOOR_PLANS_DELETE_MESSAGE_SUCCESS,
    FLOOR_PLANS_DELETE__MESSAGE_FAILED
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_FLOOR_PLANS_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_FLOOR_PLANS_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_FLOOR_PLANS_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case FLOOR_PLANS_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case FLOOR_PLANS_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case FLOOR_PLANS_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
